(() => {
  const SELECTOR = '[data-gemlay-offer-slider]';

  function initOfferSlider(slider) {
    if (!slider || slider.dataset.gemlayOfferReady === 'true') return;

    const slides = [...slider.querySelectorAll('[data-gemlay-offer-slide]')];
    if (!slides.length) return;

    slider.dataset.gemlayOfferReady = 'true';
    const dots = [...slider.querySelectorAll('[data-gemlay-offer-dot]')];
    const count = slider.querySelector('[data-gemlay-offer-count]');
    const prev = slider.querySelector('[data-gemlay-offer-prev]');
    const next = slider.querySelector('[data-gemlay-offer-next]');
    const autoplayMs = Math.max(3000, Number(slider.dataset.autoplayMs || 5000));
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    let timer = null;

    function render(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (slides.length < 2 || reduceMotion) return;
      timer = window.setInterval(() => render(index + 1), autoplayMs);
    }

    prev?.addEventListener('click', () => {
      render(index - 1);
      start();
    });
    next?.addEventListener('click', () => {
      render(index + 1);
      start();
    });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        render(Number(dot.dataset.index || 0));
        start();
      });
    });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);

    slider.querySelectorAll('[data-gemlay-offer-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const code = button.dataset.gemlayOfferCode || '';
        if (!code) return;
        try {
          await navigator.clipboard.writeText(code);
          const label = button.querySelector('[data-gemlay-offer-copy-label]');
          if (label) label.textContent = 'Copied';
          window.setTimeout(() => {
            if (label) label.textContent = 'Copy';
          }, 1400);
        } catch (_) {}
      });
    });

    render(0);
    start();
  }

  function initAll(context = document) {
    if (context.matches?.(SELECTOR)) initOfferSlider(context);
    context.querySelectorAll?.(SELECTOR).forEach(initOfferSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
